import { render, staticRenderFns } from "./TableSelectAlert.vue?vue&type=template&id=2f8b016c&scoped=true"
import script from "./TableSelectAlert.vue?vue&type=script&lang=ts"
export * from "./TableSelectAlert.vue?vue&type=script&lang=ts"
import style0 from "./TableSelectAlert.vue?vue&type=style&index=0&id=2f8b016c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b016c",
  null
  
)

export default component.exports